export enum OnboardingPercentages {
  ZeroConditionMatch = 10,
  OneConditionMatch = 50,
  TwoConditionMatch = 90,
}
